import React, { useContext, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { Modal } from "components/atoms/Modal/index";
import { AppContext } from "lib/contexts";
import { AppReducerActionType, IModelConfig, UserPremiumType } from "types";
import { Label, Span, SubTitle } from "utils/styling/typography.styled";
import { DefaultModelContainer, LabelWrapper, ModalContent, ModelCard, ModelContainer, ModelName, NewBadge, SubscriberOnlyBadge } from "./ModelSelection.styled";
interface ModelSelectionProps {
  modelConfigs: IModelConfig[];
  onConfigChange: (newConfig: any) => void;
  selectedModel: IModelConfig | null;
  setSelectedModel: (model: IModelConfig | null) => void;
}
const ModelSelection: React.FC<ModelSelectionProps> = ({
  modelConfigs,
  onConfigChange,
  selectedModel,
  setSelectedModel
}) => {
  const {
    state,
    dispatch
  } = useContext(AppContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const isInitialConfigSet = useRef(false);
  useEffect(() => {
    if (modelConfigs.length > 0 && !isInitialConfigSet.current && !selectedModel) {
      const defaultModel = modelConfigs[8];
      setSelectedModel(defaultModel);
      onConfigChange({
        model: defaultModel.modelName,
        cfg: defaultModel.defaultCfgScale.toString(),
        steps: defaultModel.defaultSteps.toString(),
        sampler: defaultModel.defaultSampler
      });
      isInitialConfigSet.current = true;
    }
  }, [modelConfigs, onConfigChange, selectedModel, setSelectedModel]);
  const handleModelClick = (model: IModelConfig) => {
    if (model.subscriberOnly && state.userPremiumLevel === UserPremiumType.NONE) {
      dispatch({
        type: AppReducerActionType.SHOW_SUBSCRIPTION_TABLE,
        payload: {
          ...state,
          showSubscriptionTable: true
        }
      });
      return;
    }
    setSelectedModel(model);
    onConfigChange({
      model: model.modelName,
      cfg: model.defaultCfgScale.toString(),
      steps: model.defaultSteps.toString(),
      sampler: model.defaultSampler
    });
    setModalIsOpen(false);
  };
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  return <div data-sentry-component="ModelSelection" data-sentry-source-file="index.tsx">
            <LabelWrapper data-sentry-element="LabelWrapper" data-sentry-source-file="index.tsx">
                <Label data-sentry-element="Label" data-sentry-source-file="index.tsx">Select a Model</Label>
            </LabelWrapper>
            {selectedModel && <DefaultModelContainer onClick={openModal}>
                    <Image src={selectedModel.thumbnailUrl} alt={selectedModel.modelName} width={50} height={50} priority />
                    <ModelName>{selectedModel.modelName}</ModelName>
                </DefaultModelContainer>}
            {selectedModel && <Modal open={modalIsOpen} handleBackdropClick={closeModal} disableBackdropClick={false}>
                    <ModalContent>
                        <SubTitle>Select a Model</SubTitle>
                        <ModelContainer>
                            {modelConfigs.map(model => <ModelCard key={model.modelName} onClick={() => handleModelClick(model)}>
                                    <Image src={model.thumbnailUrl} alt={model.modelName} width={150} height={150} style={{
              objectFit: "cover",
              width: "100%",
              height: "auto"
            }} />
                                    <ModelName>
                                        <Span>{model.modelName}</Span>
                                        {(model.modelName === "Flux.Pro" || model.modelName === "Playground V2.5" || model.modelName === "AuraFlow" || model.modelName === "Zavy Chroma XL" || model.modelName === "Ideogram 2.0") && <NewBadge>✨ NEW ✨</NewBadge>}
                                        {model.subscriberOnly && <SubscriberOnlyBadge>
                                                Sub Only ✨
                                            </SubscriberOnlyBadge>}
                                    </ModelName>
                                </ModelCard>)}
                        </ModelContainer>
                    </ModalContent>
                </Modal>}
        </div>;
};
export default ModelSelection;